import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca estudié portugués?',
    a: 'Sí. El Tomo 1 arranca desde cero con el Sistema de Mapeo Rioplatense™ que usa tu español como ventaja, no como obstáculo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con acceso a todo. Desde el celular, tablet o computadora. Sin instalaciones. Acceso de por vida.'
  }, {
    q: '¿El Nivel PRO es necesario?',
    a: 'Si tu objetivo es comunicarte en situaciones cotidianas y viajar — el Megapack base alcanza y sobra. Si trabajás o querés trabajar con empresas brasileñas en un contexto técnico — el PRO es el complemento ideal.'
  }, {
    q: '¿Cuánto tiempo lleva?',
    a: '20-30 minutos diarios durante 90 días. La mayoría reporta primeras conversaciones reales en 2-3 semanas.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 7 días, 100% del dinero, sin preguntas. Se hace efectiva con un solo email.'
  }, {
    q: '¿Es portugués de Portugal o de Brasil?',
    a: 'Es 100% portugués brasileño, enfocado en cómo hablan realmente en el día a día y en los negocios en Brasil.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-black" data-id="element-74">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-75">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-76">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, i) => <div key={i} className="border border-emerald-900/40 rounded-2xl overflow-hidden bg-zinc-900/60" data-id="element-78">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 hover:bg-zinc-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-79">
                <span className="font-bold text-white pr-4" data-id="element-80">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-emerald-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-81" />
              </button>

              <AnimatePresence data-id="element-82">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-83">
                    <div className="px-6 pb-5 text-zinc-200 leading-relaxed border-t border-emerald-900/30 pt-3" data-id="element-84">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}